<template>
  <section v-if="showStoredCards" class="card">
    <translate class="section-heading"> Saved cards </translate>
    <user-stored-card
      v-for="(card, id) in storedCards"
      :key="id"
      :card="card.state.context"
      :is-removing="card.state.matches('removing')"
      @remove="removeCard(id)"
    />
  </section>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'
import { getUserStoredCardsMachine } from '../inversify.config'
import { UserStoredCardsMachineInterpreter } from '../machines/UserStoredCardsMachine'

@Component
class UserStoredCards extends Vue {
  userStoredCardsMachine = getUserStoredCardsMachine(
    useRoute().params.lang || 'en-gb',
  )

  currentUserStoredCardsMachineState:
    | UserStoredCardsMachineInterpreter['initialState']
    | null = null

  get storedCards() {
    return this.currentUserStoredCardsMachineState
      ? this.currentUserStoredCardsMachineState.context.cards
      : {}
  }

  private startUserStoredCardsMachine() {
    this.userStoredCardsMachine
      ?.onTransition((state) => {
        if (state.changed) {
          this.currentUserStoredCardsMachineState = state
        }
      })
      .start()
  }

  created() {
    this.startUserStoredCardsMachine()
  }

  removeCard(id: string) {
    this.storedCards[id].send({ type: 'REMOVE' })
  }

  get showStoredCards() {
    return Object.values(this.storedCards).length
  }
}

export default toNative(UserStoredCards)
</script>
